import React, { useState, useEffect } from "react";
import FormInput from "../../input";
import { Footer, Form, Page, Overlay, ErrorMessage, FormMainContainer } from "./styles";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Header, Tab, TabContainer, TabHeader, TabLink } from "../manage/styles";
import { useDispatch, useSelector } from "react-redux";
import { CloseButton, TabItems, TabList, TabText } from "../popup/styles";
import { DwonlaodIcon, GetIcon } from "../../../../icons";
import { AddButton, ButtonPanel, FileButton, Filters, More, NoData, Table, Td, Tr } from "../styles";
import { RowContainer } from "../../../styles/containers/styles";
import * as xlsx from "xlsx";
import { bulkUploadData, getData, postData } from "../../../../backend/api";
import { addSelectObject } from "../../../../store/actions/select";
import SalaryData from "../../salary";
import { useNavigate } from "react-router-dom";
import AddForm from "../../../private/pages/forms/AddForm";
import { GetAccessToken } from "../../../../backend/authentication";
import axios from "axios";
import { clearLogin } from "../../../../store/actions/login";

const regexPatterns = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, // Matches valid email addresses
  cvv: /^\d{3,4}$/, // Matches 3- or 4-digit CVV codes
  svnumber: /^\d{8}[A-Za-z]\d{3}$/, // Matches German social security number format
  iban: /^[A-Za-z]{2}\d{2}[A-Za-z0-9]{1,30}$/, // Matches IBAN format
  textOnly: /^[A-Za-zÀ-ÖØ-öø-ÿ\s-]+$/, // Matches text-only input (supports European characters)
  ccn: /^\d{13,19}$/, // Matches credit card numbers (13-19 digits)
  fileNumber: /^[A-Z0-9-]+$/, // Matches file numbers with uppercase letters, digits, and dashes
  licensePlate: /^[A-Z]{3}[ -]?[A-Z0-9]{2}[ -]?[A-Z0-9]{3,5}$/i, // Matches German license plate format
  amount: /^\d+([.,]\d{1,2})?$/, // Matches valid amounts with up to 2 decimal places
  time: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/, // Matches 24-hour time format
};

const CrudForm = (props) => {
  // Use the useTranslation hook from react-i18next to handle translations
  const { t } = useTranslation();
  const { delPrivilege, setMessage, deleteHandler, updateId, setLoaderBox, api, actions,setRefreshVal, refreshView,openData } = props;
  // State to store the form input fields
  const [formState, setFormState] = useState(props.formInput);
  const [salaryItem] = useState(actions?.find((item) => item.type === "subList" && item.element === "button" && item.title==="salary"));
  // State to store the submit button's disabled status
  const [submitDisabled, setSubmitDisabled] = useState(true);
  // State to store the form values
  const [formValues, setFormValues] = useState(props.formValues);

  // State to store the validation messages
  const [formErrors, setFormErrors] = useState(props.formErrors);

  // State to store the validation messages
  const [errorCount, setErrorCount] = useState(0);

  // State to store the validation messages
  const [formBulkErrors, setBulkFormErrors] = useState([]);
  //theme colors
  const themeColors = useSelector((state) => state.themeColors);
  const user = useSelector((state) => state.login);

  const { i18n } = useTranslation();

  const [selectedLanguage] = useState(i18n.language || "de");


  const [permissions, setPermissions] = useState((user.data.user.authorisation==="advisor" && props.shortName==="advisor") ? (formValues.authorisation==="admin" ? {
          companies: true,
          statistics: true,
          advisors: true,
          settings: true,
        } : formValues.authorisation==="case-handler" ? {
          companies: true,
          statistics: false,
          advisors: false,
          settings: false,
        } : formValues.authorisation==="statistics-viewer" ? {
          companies: true,
          statistics: true,
          department: false,
          advisors: false,
          settings: false,
        } : formValues.permissions ? formValues.permissions : {
          companies: false,
          statistics: false,
          advisors: false,
          settings: false,
        }) : (formValues.authorisation==="admin" ? {
          cases: true,
          statistics: true,
          department: true,
          category: true,
          settings: true,
        } : formValues.authorisation==="case-handler" ? {
          cases: true,
          statistics: false,
          department: false,
          category: false,
          settings: false,
        } : formValues.authorisation==="statistics-viewer" ? {
          cases: false,
          statistics: true,
          department: false,
          category: false,
          settings: false,
        } : formValues.permissions ? formValues.permissions : {
          cases: false,
          statistics: false,
          department: false,
          category: false,
          settings: false,
        })
      );

  /**
   * fieldValidation is a callback function to validate a form field based on its properties
   *
   * @param {object} field - The field to be validated
   * @param {string} value - The value of the field
   *
   * @returns {number} flags - The number of validation errors for the field
   */

  // const highestPersonalNumberGet = async ()=>{
  //   await getData({},"user/highestPersonalNumber", dispatch, navigate).then((response) => {
  //     if(response.data && response.data){
  //       console.log(response.data?.highestPersonnelNumber?.personalNumber);
  //       setFormValues({...formValues, personalNumber: response.data?.highestPersonnelNumber?.personalNumber ? (response.data?.highestPersonnelNumber?.personalNumber + 1) : 1 });
  //     }
  //   });
  // }

  // useEffect(() => {
  //   if(api==="user" && !updateId){
  //     highestPersonalNumberGet()
  //   }
  // }, [])
  

  const validation = (fields, udpatedValue, formErrors, agreement, useCheckbox, index = null) => {
    const tempformErrors = { ...formErrors };
    let flags = 0;
    fields.forEach((item) => {
      if (item.name !== "_id") {
        if (item.type === "multiple") {
          item.forms.forEach((form, multipleIndex) => {
            form.forEach((inputs, index) => {
              const res = fieldValidation(inputs, typeof udpatedValue[item.name][multipleIndex][inputs.name] === "undefined" ? "" : udpatedValue[item.name][multipleIndex][inputs.name], null, udpatedValue);
              tempformErrors[item.name][multipleIndex][inputs.name] = res.tempformError;
              flags += res.flag; //?res.flag:0;
            });
          });
        } else if (item.validation === "greater") {
          const res = fieldValidation(item, typeof udpatedValue[item.name] === "undefined" ? "" : udpatedValue[item.name], typeof udpatedValue[item.reference] === "undefined" ? new Date() : udpatedValue[item.reference], udpatedValue);
          tempformErrors[item.name] = res.tempformError;
          flags += res.flag; //?res.flag:0;
        } else {
          const res = fieldValidation(item, typeof udpatedValue[item.name] === "undefined" ? "" : udpatedValue[item.name], null, udpatedValue);
          tempformErrors[item.name] = res.tempformError;
          flags += res.flag; //?res.flag:0;
        }
      }
    });

    const agreementRes = agreementValidation(agreement, useCheckbox);
    tempformErrors["captchaError"] = agreementRes.tempformError;
    flags += agreementRes.flag; //?res.flag:0;
    if (index === null) {
      setFormErrors(tempformErrors);
    } else {
      //setSubmitDisabled((prev) => (flags > 0 ? true : index === 0 ? false : prev));
      //console.log("disable", flags);
      return { tempformErrors, flags };
    }

    setSubmitDisabled(flags > 0 ? true : false);
    if (flags === 0) {
      return true;
    } else {
      return false;
    }
  };

  const fieldValidation = (field, value, ref = new Date(), udpatedValue = {}) => {
    let flag = 0;
    let tempformError = "";

    if (!field.update && props.formType === "put") {
      return { flag, tempformError };
    }
    if (!field.add && props.formType === "post") {
      return { flag, tempformError };
    }
    if (field.condition) {
      if (udpatedValue[field.condition.item] === field.condition.if) {
        if (field.condition.then === "disabled") {
          return { flag, tempformError };
        }
      } else {
        if (field.condition.else === "disabled") {
          return { flag, tempformError };
        }
      }
    }
    if (!field.required && value?.length === 0) {
      return { flag, tempformError };
    }

    switch (field.validation) {
      case "email":
        if (!regexPatterns.email.test(value)) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
        break;
  
      case "cvv":
        if (!regexPatterns.cvv.test(value)) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
        break;
  
      case "svnumber":
        if (!regexPatterns.svnumber.test(value)) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
        break;
  
      case "iban":
        if (!regexPatterns.iban.test(value)) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
        break;
  
      case "textonly":
        if (!regexPatterns.textOnly.test(value)) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
        break;
  
      case "ccn":
        if (!regexPatterns.ccn.test(value)) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        } else {
          let sum = 0;
          for (let i = 0; i < value.length; i++) {
            let digit = parseInt(value[i]);
            if (i % 2 === 0) {
              digit *= 2;
              if (digit > 9) {
                digit -= 9;
              }
            }
            sum += digit;
          }
          if (sum % 10 !== 0) {
            tempformError = t("validContent", { label: t(field.label) });
            flag += 1;
          }
        }
        break;
  
      case "expiry":
        if (!validateExpiry(value)) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
        break;
  
      case "fileNumber":
        if (!regexPatterns.fileNumber.test(value)) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
        break;
  
      case "licensePlate":
        if (!regexPatterns.licensePlate.test(value)) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
        break;
  
      case "greater":
        const referedDate = new Date(ref);
        if (new Date(value) < referedDate) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
        break;
  
      case "amount":
        if (!regexPatterns.amount.test(value)) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
        break;
  
      case "datetime":
        if (!moment(value, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
        break;
  
      case "time":
        if (!regexPatterns.time.test(value)) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
        break;
  
      case "text":
        // No validation for general text
        break;

      case "passwordMatch":
        const validatePass = (password) => {
          if (!password) return false;
          if (password.length < 6) return false;
          if (password.length > 15) return false;
          
          let upper = 0;
          let lower = 0;
          let number = 0;
          let special = 0;
          
          for (let i = 0; i < password.length; i++) {
            const char = password[i];
            if (/[0-9]/.test(char)) number++;
            else if (char.toUpperCase() !== char.toLowerCase()) {
              if (char === char.toUpperCase()) upper++;
              else lower++;
            }
            else special++;
          }
          
          if (upper < 1 || lower < 1 || number < 1 || special < 1) return false;
          
          return true;
        };

        if (field.name === "newPassword" || field.name === "password") {
          if (!validatePass(value)) {
            tempformError = t("passwordCriteria");
            flag += 1;
            break;
          }
        }

        if (udpatedValue["newPassword"] !== udpatedValue["confirmPassword"]) {
          tempformError = t("passwordEqual");
          flag += 1;
        }
        break;
  
      default:
        break;
    }
    if (field.type === "image" || field.type === "file") {
      if (value.length === 0) {
        tempformError = t("validContent", { label: t(field.label) });
        flag += 1;
      }
    } else {
      if (field.required && value?.length === 0) {
        tempformError = t("required", { label: t(field.label) });
        flag += 1;
      } else if (field.minimum > value?.length) {
        tempformError = t("requiredMinimum", { minimum: field.minimum, label: t(field.label) });

        flag += 1;
      } else if (field.maximum < value?.length) {
        tempformError = t("maxLimit", { maximum: field.maximum, label: t(field.label) });
        flag += 1;
      }
    }
    return { flag, tempformError };
  };
  function validateExpiry(expiry) {
    let month = parseInt(expiry.substring(0, 2));
    let year = parseInt("20" + expiry.substring(3));
    let now = new Date();
    let currentYear = now.getFullYear();
    let currentMonth = now.getMonth() + 1; // JavaScript months are 0-11
    if (year < currentYear || (year === currentYear && month < currentMonth)) {
      return false; // Expiry date is in the past
    }
    if (month < 1 || month > 12) {
      return false; // Invalid month
    }
    return true;
  }

  useEffect(() => {}, [formState]);

  const agreementValidation = (agreement, useCheckbox) => {
    let flag = 0;
    let tempformError = "";
    if (agreement !== true && useCheckbox === true) {
      tempformError = t("required", { label: t("agreement") });
      flag += 1;
    }
    return { flag, tempformError };
  };
  const handleBulkChange = (sl = 0, event, id, type = "text", sub = null, data = {}) => {
    data = jsonData[sl];
    console.log(data);
    const fullData = [...jsonData];
    const field = formState[id];
    let value = "";
    if (type === "checkbox") {
      value = event;
    } else if (type === "select") {
      value = event.id;
    } else if (type === "multiSelect") {
      const items = data[field.name];
      const index = items.findIndex((item) => item === event.id);

      if (index === -1) {
        // If event._id doesn't exist, push it to the items array
        items.push(event.id);
      } else {
        // If event._id already exists, remove it from the items array
        items.splice(index, 1);
      }
      value = items;
    } else if (field.validation === "licensePlate") {
      value = event.target.value
        .toString()
        .toUpperCase()
        .replace(/[^a-zA-Z0-9ÄÖÜß]/g, "");
    } else if (type === "text" || type === "number" || type === "password" || type === "color") {
      value = event.target.value;
    } else if (type === "search") {
      value = JSON.stringify(event);
    } else if (type === "image" || type === "file") {
      value = event.target.files;
    } else if (type === "datetime" || type === "time") {
      if (event) {
        value = event.toISOString();
      } else {
        value = "";
      }
    } else if (type === "date") {
      if (event) {
        event.setHours(14, 0, 0, 0); // Set time to 14:00 (2:00 PM)
        value = event.toISOString();
      } else {
        value = "";
      }
    } else {
      value = event.target.getAttribute("value");
    }

    const udpateValue = {
      ...data,
      [field.name]: value,
    };
    fullData[sl] = udpateValue;
    setJsonData(fullData);
    let isValidate = 0;
    const formErrorTemp = [...formBulkErrors];
    console.log("formErrorTemp", formErrorTemp);
    fullData.map((data, index) => {
      const errorItem = validation(formState, data, formErrorTemp[index], false, false, sl);
      formErrorTemp[index] = errorItem.tempformErrors;
      isValidate += errorItem.flags;
      return true;
    });
    setBulkFormErrors(formErrorTemp);
    setErrorCount(isValidate);
    if (isValidate > 0) {
      setSubmitDisabled(true);
    } else {
      setSubmitDisabled(false);
    }
    return isValidate;
  };
  const handleChange = (sl = 0, event, id, type = "text", sub = null, data = {}) => {
    // Getting current field
    
    const field = formState[id];
    if (sub === null) {
      let updateValue = {
        ...formValues
      };
      let updateState = [
        ...formState
      ];
      let value = "";
      if (type === "checkbox") {
        value = event;
      } else if (type === "select") {
        value = event.id;
      } else if (type === "multiSelect") {
        const items = formValues[field.name];
        console.log("items", items, event);
        const index = items.findIndex((item) => item._id === event.id);

        if (index === -1) {
          // If event._id doesn't exist, push it to the items array
          items.push(event.id);
        } else {
          // If event._id already exists, remove it from the items array
          items.splice(index, 1);
        }
        value = items;
      } else if (field.validation === "licensePlate") {
        value = event.target.value
          .toString()
          .toUpperCase()
          .replace(/[^a-zA-Z0-9ÄÖÜß]/g, "");
      } else if (type === "text" || type === "number" || type === "password" || type === "color") {
        value = event.target.value;
      } else if (type === "search") {
        value = JSON.stringify(event);
      } else if (type === "image" || type === "file") {
        value = event.target.files;
      } else if (type === "datetime" || type === "time") {
        if (event) {
          if(field.name==="startDate"){
            if(formValues.endDate && new Date(event) > new Date(formValues.endDate)){
              updateValue["endDate"] = event.toISOString();
            }
            if(formValues.endDate) updateState[id].maxDate = new Date(updateValue.endDate)
              updateState.forEach((value) => {
                if(value.name === "endDate") value.minDate = new Date(event);
              }); 
          } else if(field.name==="endDate"){
            if(formValues.startDate && new Date(event) < new Date(formValues.startDate)){
              updateValue["startDate"] = event.toISOString();
            }
            if(formValues.startDate) updateState[id].minDate = new Date(updateValue.startDate);
            updateState.forEach((value) => {
              if(value.name === "startDate") value.maxDate = new Date(event);
            });
          }
          value = event.toISOString();
        } else {
          value = "";
        }
      } else if (type === "date") {
        if (event) {
          event.setHours(14, 0, 0, 0); // Set time to 14:00 (2:00 PM)
          if(field.name==="startDate"){
            if(formValues.endDate && new Date(event) > new Date(formValues.endDate)){
              updateValue["endDate"] = event.toISOString();
            }
            if(formValues.endDate) updateState[id].maxDate = new Date(updateValue.endDate)
              updateState.forEach((value) => {
                if(value.name === "endDate") value.minDate = new Date(event);
              }); 
          } else if(field.name==="endDate"){
            if(formValues.startDate && new Date(event) < new Date(formValues.startDate)){
              updateValue["startDate"] = event.toISOString();
            }
            if(formValues.startDate) updateState[id].minDate = new Date(updateValue.startDate);
            updateState.forEach((value) => {
              if(value.name === "startDate") value.maxDate = new Date(event);
            });
          } else if(field.name==="contractFrom"){
            if(formValues.contractEnd && new Date(event) > new Date(formValues.contractEnd)){
              updateValue["contractEnd"] = event.toISOString();
            }
            if(formValues.contractEnd) updateState[id].maxDate = new Date(updateValue.contractEnd)
            updateState.forEach((value) => {
              if(value.name === "contractEnd") value.minDate = new Date(event);
            }); 
          } else if(field.name==="contractEnd"){
            if(formValues.contractFrom && new Date(event) < new Date(formValues.contractFrom)){
              updateValue["contractFrom"] = event.toISOString();
            }
            if(formValues.contractFrom) updateState[id].minDate = new Date(updateValue.contractFrom);
            updateState.forEach((value) => {
              if(value.name === "contractFrom") value.maxDate = new Date(event);
            });
          }
          value = event.toISOString();
        } else {
          value = "";
        }
      } else {
        value = event.target.getAttribute("value");
      }

      updateValue[field.name] = value;
    
      if(api.includes("emp_dev_meeting") && updateValue[field.name] && field.name==="form" && (formValues.formTitle === "" || formValues.formTitle === undefined || formValues.formTitle === null)){
        updateValue["formTitle"] = event.value;
      }

      // Creating an updated field
      // updating the formm values
      setFormValues(updateValue);
      setFormState(updateState);
      // Validating the fields
      if (validation(formState, updateValue, formErrors)) {
        // Here we can write any state updation
      }
    } else {
      const main = formState[sub.index];
      const field = main.forms[sub.multipleIndex][id];
      const updateValue = { ...formValues };
      updateValue[main.name][sub.multipleIndex][field.name] = event.target.value;
      setFormValues(updateValue);
      // Validating the fields
      if (validation(formState, updateValue, formErrors)) {
        // Here we can write any state updation
      }
    }
  };

  const submitChange = async(event) => {
    event.preventDefault();
    try {
      if(activeTab === "salary"){
        setLoaderBox(true);
      await postData(salaryValues, `${salaryItem?.params?.api}/${openData?.data?._id}`, dispatch, navigate)
        .then((response) => {
          if (response.status === 200) {
            // setMessage({ type: 1, content: `The '${t(shortName)}' saved successfully!`, proceed: "Okay" });
            setMessage({ type: 1, content: t("saved", { shortName: t(salaryItem?.params?.shortName) }), proceed: "Okay", code: 200 });
            if(setRefreshVal)
              setRefreshVal(true);
            refreshView();
            closeModal();
            // udpateView(0);
          } else if (response.status === 404) {
            setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
          } else {
            setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
          }
          setLoaderBox(false);
        })
        .catch((error) => {
          setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
          setLoaderBox(false);
        });
      }
      else if (props.bulkUpload) {
        const fullData = [...jsonData];
        const formErrorTemp = [...formBulkErrors];
        let isValidate = 0;
        fullData.map((data, index) => {
          const errorItem = validation(formState, data, formErrorTemp[index], false, false, index);
          formErrorTemp[index] = errorItem.tempformErrors;
          isValidate += errorItem.flags;
          return true;
        });
        setErrorCount(isValidate);
        if (isValidate > 0) {
          setSubmitDisabled(true);
        } else {
          props.submitHandler(fullData, formState);
        }
      } else {
        if (validation(formState, formValues, formErrors)) {
          if(props.shortName==="user"){
            const updatedValues = {...formValues, permissions};
            props.submitHandler(updatedValues, formState);
          } else if(props.shortName==="advisor"){
            const permission = permissions.companies ? {
              cases: true,
              statistics: true,
              department: true,
              category: true,
              settings: true,
            } : {
              cases: false,
              statistics: false,
              department: false,
              category: false,
              settings: false,
            }
            const updatedValues = {...formValues, partnerPermissions: permissions, permissions: permission };
            props.submitHandler(updatedValues, formState);
          } else{
            props.submitHandler(formValues, formState);
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const closeModal = () => {
    props.isOpenHandler(false);
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [groupedTabs, setGroupedTabs] = useState(
    (props.formView ?? "") === "tabs"
      ? formState?.length > 0 &&
          formState.reduce((result, attribute, index) => {
            const tabName = attribute.tab;
            const existingTab = result.find((tab) => tab.tabName === tabName);
            const attributeTemp = { ...attribute, index };
            if (existingTab) {
              existingTab.tabItems.push(attributeTemp);
            } else {
              result.push({ tabName, tabItems: [attributeTemp] });
            }

            return result;
          }, [])
      : []
  );
  const [activeTab, setActiveTab] = useState(groupedTabs[0]?.tabName);

  useEffect(() => {
     let tabs = 
    (props.formView ?? "") === "tabs"
      ? formState?.length > 0 &&
          formState.reduce((result, attribute, index) => {
            const tabName = attribute.tab;
            const existingTab = result.find((tab) => tab.tabName === tabName);
            const attributeTemp = { ...attribute, index };
            if (existingTab) {
              existingTab.tabItems.push(attributeTemp);
            } else {
              result.push({ tabName, tabItems: [attributeTemp] });
            }

            return result;
          }, [])
      : []
    setGroupedTabs(tabs);
  }, [formState])

  // bulk uplaod format
  const [jsonData, setJsonData] = useState(null);
  const uploadData = async (event) => {
    setLoaderBox(true);
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const errorData = [];
        const data = new Uint8Array(e.target.result);
        const workbook = xlsx.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = xlsx.utils.sheet_to_json(worksheet);
        const selectData = {};

        const finalData = await Promise.all(
          json.map(async (item, itemIndex) => {
            const formErrorItem = {};
            const temp = {};
            let date = new Date();

            await Promise.all(
              formState.map(async (attribute) => {
                if (attribute.add) {
                  const itemValue = item[t(attribute.label)] ? item[t(attribute.label)] : item[t(attribute.label, { lng: selectedLanguage === "en" ? "de" : "en" })];
                  let val = "";

                  if (attribute.type === "checkbox") {
                    let bool = JSON.parse(attribute.default === "false" || attribute.default === "true" ? attribute.default : "false");
                    val = bool;
                  } else if (attribute.type === "multiSelect") {
                    val = [];
                  } else if (attribute.type === "text") {
                    val = "";
                  } else if (attribute.type === "datetime" || attribute.type === "date" || attribute.type === "time") {
                    if (attribute.default === "0") {
                      // Set hour to 00:00
                      date.setUTCHours(0, 0, 0, 0);
                      val = date.toISOString();
                    } else if (attribute.default === "1") {
                      // Set hour to 23:59
                      date.setUTCHours(23, 59, 0, 0);
                      val = date.toISOString();
                    } else {
                      // Set hour to current time
                      val = date.toISOString();
                    }
                    if (attribute.add) {
                      val = attribute.default === "empty" ? "" : date.toISOString();
                    }
                  } else if (attribute.type === "image" || attribute.type === "file") {
                    if (attribute.add) {
                      val = "";
                    }
                    val = "";
                  } else {
                    val = attribute.default ?? "";
                    if (attribute.type === "select") {
                      val = attribute.default ?? "";
                    }
                  }
                  temp[attribute.name] = val ?? "";
                  if (attribute.upload) {
                    temp[attribute.name] = itemValue ?? val ?? "";
                    formErrorItem[attribute.name] = "";
                    if (attribute.apiType === "API") {
                      if (!selectData[attribute.selectApi]) {
                        const response = await getData({}, `${attribute.selectApi}`, dispatch, navigate);
                        selectData[attribute.selectApi] = response.data;
                        if (response.status === 200) {
                          dispatch(addSelectObject(response.data, attribute.selectApi));
                        }
                      }
                      const name = attribute.displayValue ? attribute.displayValue : attribute.showItem === "locale" ? selectedLanguage : "value";
                      const foundItem = selectData[attribute.selectApi].find((option) => option[name] === itemValue);
                      if (foundItem) {
                        temp[attribute.name] = foundItem.id;
                      }
                    }
                  }
                }
              })
            );
            errorData.push(formErrorItem);
            return temp;
          })
        );

        let isValidate = 0;
        finalData.forEach((data, index) => {
          const errorItem = validation(formState, data, errorData[index], false, false, index);
          errorData[index] = errorItem.tempformErrors;
          isValidate += errorItem.flags;
        });

        setErrorCount(isValidate);
        setSubmitDisabled(isValidate > 0);
        setBulkFormErrors(errorData);
        setJsonData(finalData);
        setLoaderBox(false);
      };

      reader.readAsArrayBuffer(file);
    }
  };

  const bulkUplaodFormat = () => {
    const excelData = [];
  
    // Iterate over the form state to create rows for the Excel sheet
    formState.forEach((attribute) => {
      if (attribute.upload) {
        switch (attribute.name) {
          case "firstName":
            excelData[0]={...excelData[0], [t(attribute.label)]: "Max" };
            excelData[1]={...excelData[1], [t(attribute.label)]: "Lisa" };
            break;
    
          case "lastName":
            excelData[0]={...excelData[0], [t(attribute.label)]: "Müller" };
            excelData[1]={...excelData[1], [t(attribute.label)]: "Hausenberg" };
            break;
    
          case "mobileNumber":
            excelData[0]={...excelData[0], [t(attribute.label)]: "+491731654789" };
            excelData[1]={...excelData[1], [t(attribute.label)]: "01732548654" };
            break;
    
          case "email":
            excelData[0]={...excelData[0], [t(attribute.label)]: "hofasd@web.de" };
            excelData[1]={...excelData[1], [t(attribute.label)]: "test@gmail.com" };
            break;
    
          default:
            // Add a blank row for other attributes
            excelData[0]=({...excelData[0], [t(attribute.label)]: "" });
            excelData[1]=({...excelData[1], [t(attribute.label)]: "" });
            break;
        }
      }
    });
    
  
    // Create worksheet from JSON data
    const worksheet = xlsx.utils.json_to_sheet(excelData);
  
    // Create workbook and append worksheet
    const workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, t("report"));
  
    // Save the Excel file
    xlsx.writeFile(workbook, "bulkupload.xlsx");
  };
  
  const bulkUploadHandler = async (event) => {
    setLoaderBox(true);
    await bulkUploadData({ data: JSON.stringify(jsonData) }, `${api}/bulk-upload`)
      .then((response) => {
        if (response.status === 200) {
          setJsonData(response.data.alreadyExist);
          setMessage({ type: 1, content: t("bulkUploadMessage", { exist: response.data.alreadyExist.length, added: response.data.added.length }), proceed: "Okay", code: 200 });
          if (response.data.alreadyExist.length === 0) {
            submitChange(event);
          }
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        alert(error);
        setLoaderBox(false);
      });
  };
  const handleSingleDataUpload = async (e, payload, index) => {
    e.preventDefault();
    setLoaderBox(true);
    console.log("payload", payload);
    await postData(payload, `${api}`, dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          let val = JSON.parse(JSON.stringify(jsonData));
          val.splice(index, 1);
          setJsonData(val);
          setMessage({ type: 1, content: t("saved", { shortName: t(`employee`) }), proceed: "Okay", code: 200 });
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        alert(error);
        setLoaderBox(false);
      });
  };

  const [salaryValues, setSalaryValues] = useState([])
    const [errroInput, setErrorInput] = useState([]);

    useEffect(() => {
      let items = actions?.find((item) => item.type === "subList" && item.element === "button" && item.title==="salary")
        const addValuesTemp = {
            addValues: {},
            updateValues: {},
            viewValues: {},
            errorValues: {},
            filterValues: {},
          };
        let tempFilter = false;
        let date = new Date();
        items?.attributes?.forEach((item) => {
          if (item.type === "checkbox") {
            let bool = JSON.parse(item.default === "false" || item.default === "true" ? item.default : "false");
            if (item.add) {
              addValuesTemp.addValues[item.name] = bool;
            }
            addValuesTemp.updateValues[item.name] = bool;
          } else if (item.type === "multiSelect") {
            addValuesTemp.addValues[item.name] = [];
            addValuesTemp.errorValues[item.name] = [];
          } else if (item.type === "datetime" || item.type === "date" || item.type === "time") {
            if (item.default === "0") {
              // Set hour to 00:00
              date.setUTCHours(0, 0, 0, 0);
              addValuesTemp.updateValues[item.name] = date.toISOString();
            } else if (item.default === "1") {
              // Set hour to 23:59
              date.setUTCHours(23, 59, 0, 0);
              addValuesTemp.updateValues[item.name] = date.toISOString();
            } else {
              // Set hour to current time
              addValuesTemp.updateValues[item.name] = date.toISOString();
            }
            if (item.add) {
              addValuesTemp.addValues[item.name] = item.default === "empty" ? "" : date.toISOString();
            }
          } else if (item.type === "image" || item.type === "file") {
            if (item.add) {
              addValuesTemp.addValues[item.name] = "";
              addValuesTemp.addValues["selected_" + item.name] = [];
            }
            addValuesTemp.updateValues[item.name] = "";
            addValuesTemp.updateValues["selected_" + item.name] = [];
          } else if (item.type === "select" && item.name==="company") {
            if (item.add) {
              addValuesTemp.addValues[item.name] = user.data.user.company || "";
            }
          } else {
            if (item.add) {
              addValuesTemp.addValues[item.name] = item.default;
            }
            addValuesTemp.updateValues[item.name] = item.default;
            if (item.type === "select") {
              if ((item.filterType ?? "multiSelect") === "multiSelect") {
                addValuesTemp.filterValues[item.name] = item.default?.length > 0 ? [item.default] : [];
              } else {
                addValuesTemp.filterValues[item.name] = item.default;
              }
              tempFilter = true;
            }
          }
          addValuesTemp.errorValues[item.name] = "";
          addValuesTemp.filterValues["searchkey"] = "";
        });

        setSalaryValues(addValuesTemp.addValues);
        setErrorInput(addValuesTemp.errorValues);

    }, [actions])

    const handleSalaryChange = (sl = 0, event, id, type = "text", sub = null, data = {}) => {
      // Getting current field
      const field = salaryItem?.attributes[id];
      if (sub === null) {
        let value = "";
        if (type === "checkbox") {
          value = event;
        } else if (type === "select") {
          value = event.id;
        } else if (type === "multiSelect") {
          const items = salaryValues[field.name];
          const index = items.findIndex((item) => item === event.id);
  
          if (index === -1) {
            // If event._id doesn't exist, push it to the items array
            items.push(event.id);
          } else {
            // If event._id already exists, remove it from the items array
            items.splice(index, 1);
          }
          value = items;
        } else if (field.validation === "licensePlate") {
          value = event.target.value
            .toString()
            .toUpperCase()
            .replace(/[^a-zA-Z0-9ÄÖÜß]/g, "");
        } else if (type === "text" || type === "number" || type === "password" || type === "color") {
          value = event.target.value;
        } else if (type === "search") {
          value = JSON.stringify(event);
        } else if (type === "image" || type === "file") {
          value = event.target.files;
        } else if (type === "datetime" || type === "time") {
          if (event) {
            value = event.toISOString();
          } else {
            value = "";
          }
        } else if (type === "date") {
          if (event) {
            event.setHours(14, 0, 0, 0); // Set time to 14:00 (2:00 PM)
            value = event.toISOString();
          } else {
            value = "";
          }
        } else {
          value = event.target.getAttribute("value");
        }
  
        const udpateValue = {
          ...salaryValues,
          [field.name]: value,
        };
        // console.log(udpateValue);
        // Creating an updated field
        // updating the formm values
        setSalaryValues(udpateValue);
        if (validation(salaryItem?.attributes, udpateValue, errroInput)) {
          // Here we can write any state updation
        }
      } else {
        const main = salaryItem?.attributes[sub.index];
        const field = main.forms[sub.multipleIndex][id];
        const udpateValue = { ...salaryValues };
        udpateValue[main.name][sub.multipleIndex][field.name] = event.target.value;
        setSalaryValues(udpateValue);
        // Validating the fields
        if (validation(salaryItem?.attributes, udpateValue, errroInput)) {
          // Here we can write any state updation
        }
      }
    };
  // const profileImageLink = profileImage?.length > 2 && formValues["photo"] ? process.env.REACT_APP_CDN.toString() + formValues["photo"]?.toString() : `${process.env.REACT_APP_CDN.toString()}uploads/profile/profile.jpg`;

  const handleSubmitEmpDevForm = async (form) => {
      let token = GetAccessToken();
      try {
        const response = props?.updateId ? await axios.put(`${process.env.REACT_APP_API}emp_dev_form/${props?.updateId}`, form, {
                headers: {
                  "Content-Type": "application/json",
                  "x-access-token": token,
                },
              }) : await axios.post(`${process.env.REACT_APP_API}emp_dev_form`, form, {
                headers: {
                  "Content-Type": "application/json",
                  "x-access-token": token,
                },
              });
              if (response.status === 200) {
                // setMessage({ type: 1, content: `The '${t(shortName)}' saved successfully!`, proceed: "Okay" });
                setMessage({ type: 1, content: t("saved", { shortName: t(props.shortName) }), proceed: "Okay", code: 200 });
                if(setRefreshVal)
                  setRefreshVal(true);
                refreshView();
                closeModal();
              } else if (response.status === 401) {
                try {
                  dispatch(clearLogin());
                  navigate("/");
                  navigate(0);
                } catch (error) {}
              }
      } catch (error) {
        
      } 
    }


  return (
    <Overlay className={`${props.login??""} ${props.shortName??""} ${props.formView??""} ${props.formMode ? props.formMode : ""} ${props.plainForm ? " plain" : " popup"}`}>
      <Page className={`${props.formMode ?? " "} ${props.formView} ${props.shortName??""}`}>
        <Header className={`${props.plainForm ? " plain" : " popup"} ${props.shortName??""}`}>
          <span>{props.header ? props.header : "Login"}</span>
          {props.plainForm!=="plain" && <CloseButton theme={themeColors} onClick={closeModal}>
            <GetIcon icon={"Close"} />
          </CloseButton>}
        </Header>
        <FormMainContainer>
        {props.shortName==="forms" ? <AddForm formId={props?.updateId} handleSubmit={handleSubmitEmpDevForm} closeModal={closeModal} /> : props.bulkUpload ? (
          <RowContainer className="list bulk">
            <ButtonPanel>
              <Filters></Filters>
              <AddButton onClick={() => bulkUplaodFormat()}>
                <DwonlaodIcon></DwonlaodIcon>
                <span>{t("Download Template")}</span>
              </AddButton>
              <FileButton type="file" accept=".xlsx, .xls" onChange={uploadData}></FileButton>
            </ButtonPanel>
            <RowContainer className=" bulk">
              {jsonData?.length > 0 ? (
                <Table>
                  {/* <thead>
                    <Tr>
                      {formState &&
                        formState.map((attribute, index) => {
                          return (attribute.upload ?? false) === true ? <Td key={props.shortName + attribute.name + index}>{t(attribute.label)}</Td> : null;
                        })}
                    </Tr>
                  </thead> */}
                  <tbody>
                    {jsonData?.map((data, rowIndex) => (
                      <Tr key={`${props.shortName}-${rowIndex}-${rowIndex}`} className={"no-border bulk"}>
                        <Td><AddButton style={{marginTop:'30px'}} disabled={!Object.values(formBulkErrors[rowIndex]).every(value => value === "")} onClick={(e)=> handleSingleDataUpload(e,data,rowIndex)}>Save</AddButton></Td>
                        {/* <Td><AddButton onClick={(e)=> handleSingleDataUpload(e,data,rowIndex)}>Save</AddButton></Td> */}
                        {formState &&
                          formState.map((attribute, index) => {
                            const itemValue = data[attribute.name];
                            if (attribute.upload ?? false) {
                            } // ? data[t(attribute.label)] : data[t(attribute.label, { lng: selectedLanguage === "en" ? "de" : "en" })];
                            return (attribute.upload ?? false) === true ? (
                              <Td className="bulk" key={index}>
                                <div>
                                  <FormInput bulkUpload={true} formValues={formValues} updateValue={{}} dynamicClass={"textarea"} placeholder={attribute.placeholder} key={`input` + index} id={index} index={rowIndex} error={formErrors[attribute.name]} value={itemValue} {...attribute} onChange={handleBulkChange} formType={props.formType} />
                                  {formBulkErrors[rowIndex]?.[attribute.name] && <p>{formBulkErrors[rowIndex][attribute.name]}</p>}
                                </div>
                              </Td>
                            ) : null;
                          })}
                      </Tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <NoData>{t("noDataUploaded")}!</NoData>
              )}
              {errorCount > 0 && <ErrorMessage style={{ marginTop: "10px" }}>{t("errorCount", { count: errorCount })}</ErrorMessage>}
            </RowContainer>
          </RowContainer>
        ) : (
          <React.Fragment>
            {(props.formView ?? "normal") === "normal" && (
              <Form className={props.formMode ?? ""}>
                {formState?.length > 0 &&
                  formState?.map((item, index) => {
                    let dynamicClass = "";
                    if (item.condition) {
                      if (formValues[item.condition.item] === item.condition.if) {
                        dynamicClass = item.condition.then;
                      } else {
                        dynamicClass = item.condition.else;
                      }
                    }
                    if(item.name==="anonymity"){
                      return;
                    }
                    return (props.formType === "put" && item.update) || (props.formType === "post" && item.add) || item.type === "title" || item.type === "info" ? <FormInput dynamicClass={dynamicClass} placeholder={item.placeHolder} key={`input` + index} id={index} error={formErrors[formState[index].name]} value={formValues[formState[index].name]} {...item} onChange={handleChange} formType={props.formType} permissions={permissions} setPermissions={setPermissions} shortName={props.shortName} /> : "";
                  })}
              </Form>
            )}

            {(props.formView ?? "") === "tabs" && groupedTabs && (
              <TabContainer className="vertical">
                <TabHeader className="vertical mh">
                  {/* <Profile>
                <img src={profileImageLink} alt="profile" />
                <h6>{`${currentData["firstName"]} ${currentData["lastName"]}`}</h6>
              </Profile> */}
                  <TabList>
                  {groupedTabs.map((group) => {
                if(group.tabName==="official"){
                  let item = actions?.find((item) => item.type === "subList" && item.element === "button" && item.title==="salary")
                  return (
                    <>
                  <React.Fragment key={group.tabName}>
                    <TabLink
                      key={`main-` + group.tabName}
                      theme={themeColors}
                      className={activeTab === group.tabName && "active"}
                      onClick={() => {
                        setActiveTab(group.tabName);
                      }}
                    >
                      <TabText> {t(group.tabName)}</TabText>
                    </TabLink>
                  </React.Fragment>
                  {item && <TabLink
                  key={`main-` + item.title}
                  theme={themeColors}
                  className={activeTab === item.title && "active"}
                  onClick={() => {
                    setActiveTab(item.title);
                  }}
                >
                  <TabText> {t(item.title)}</TabText>
                </TabLink>}
                </>
                  )
                }
                else{
                return <React.Fragment key={group.tabName}>
                  {group.tabItems?.length > 0 && (
                    <TabLink
                      key={`main-` + group.tabName}
                      theme={themeColors}
                      className={activeTab === group.tabName && "active"}
                      onClick={() => {
                        setActiveTab(group.tabName);
                      }}
                    >
                      <TabText> {t(group.tabName)}</TabText>
                    </TabLink>
                  )}
                </React.Fragment>
                }
              })}
                  </TabList>
                </TabHeader>
                <TabItems>
                  {groupedTabs.map((group) => {
                    if(group.tabName==="official"){
                      let items = actions?.find((item) => item.type === "subList" && item.element === "button" && item.title==="salary")

                      return (<>
                    <Tab className="sub" key={`sub-` + group.tabName} active={activeTab === group.tabName}>
                      <Form className={`${props.formMode ?? ""} sub`}>
                        {group.tabItems?.length > 0 &&
                          group.tabItems.map((item) => {
                            let dynamicClass = "";
                            if (item.condition) {
                              if (formValues[item.condition.item] === item.condition.if) {
                                dynamicClass = item.condition.then;
                              } else {
                                dynamicClass = item.condition.else;
                              }
                            }
                            if(item.name==="timeRecordWithoutRoaster" || item.name==="timeRecordWithShiftRoaster")
                              console.log("items", item)

                            try {
                              let updateValue = {};
                              if (item.type === "select" || item.type === "multiSelect") {
                                if (Array.isArray(item.updateOn)) {
                                  updateValue = {};
                                  item.updateOn?.forEach((itemName) => {
                                    updateValue[itemName] = formValues[itemName];
                                  });
                                } else {
                                  updateValue = { [item.updateOn]: formValues[item.updateOn] };
                                }
                              }
                              if ((props.formType === "put" && item.update) || (props.formType === "post" && item.add) || item.type === "title" || item.type === "info") {
                                return <FormInput formValues={formValues} updateValue={updateValue} dynamicClass={dynamicClass} placeholder={item.placeholder} key={`input` + item.index} id={item.index} error={formErrors[item.name]} value={formValues[item.name]} {...item} onChange={handleChange} formType={props.formType} permissions={permissions} setPermissions={setPermissions} shortName={props.shortName} />;
                              } else {
                                return null;
                              }
                            } catch (error) {
                              console.error("Error rendering FormInput:", error);
                              return null;
                            }
                          })}
                      </Form>
                    </Tab>
                    {items && <Tab className="sub" key={`sub-` + group.tabName} active={activeTab === items.title}>
                      {/* <Form className={`${props.formMode ?? ""} sub`}>
                        {items.attributes?.length > 0 &&
                          items.attributes.map((item,index) => {
                            let dynamicClass = "";
                    if (item.condition) {
                      if (formValues[item.condition.item] === item.condition.if) {
                        dynamicClass = item.condition.then;
                      } else {
                        dynamicClass = item.condition.else;
                      }
                    }
                    return <FormInput dynamicClass={dynamicClass} placeholder={item.placeHolder} key={`input` + index} id={index} {...item} onChange={handleChange} />;
                          })}
                      </Form> */}
                      <SalaryData formMode={props.formMode} items={items} t={t} salaryValues={salaryValues} errroInput={errroInput} submitDisabled={submitDisabled} handleSalaryChange={handleSalaryChange} />
                    </Tab>}
                    </>)
                    }else{
                      return <Tab className="sub" key={`sub-` + group.tabName} active={activeTab === group.tabName}>
                      <Form className={`${props.formMode ?? ""} sub`}>
                        {group.tabItems?.length > 0 &&
                          group.tabItems.map((item) => {
                            let dynamicClass = "";
                            if (item.condition) {
                              console.log(openData);
                              if(openData?.data?.companyRoster=== item.condition.if && (item.name==="timeRecordWithoutRoaster" || item.name==="timeRecordWithShiftRoaster")){
                                dynamicClass = item.condition.then;
                              }
                              else if (formValues[item.condition.item] === item.condition.if) {
                                dynamicClass = item.condition.then;
                              } else {
                                dynamicClass = item.condition.else;
                              }
                            }

                            if(item.name==="timeRecordWithoutRoaster" || item.name==="timeRecordWithShiftRoaster")
                              console.log("items", item, dynamicClass)

                            try {
                              let updateValue = {};
                              if (item.type === "select" || item.type === "multiSelect") {
                                if (Array.isArray(item.updateOn)) {
                                  updateValue = {};
                                  item.updateOn?.forEach((itemName) => {
                                    updateValue[itemName] = formValues[itemName];
                                  });
                                } else {
                                  updateValue = { [item.updateOn]: formValues[item.updateOn] };
                                }
                              }
                              if ((props.formType === "put" && item.update) || (props.formType === "post" && item.add) || item.type === "title" || item.type === "info") {
                                return <FormInput formValues={formValues} updateValue={updateValue} dynamicClass={dynamicClass} placeholder={item.placeholder} key={`input` + item.index} id={item.index} error={formErrors[item.name]} value={formValues[item.name]} {...item} onChange={handleChange} formType={props.formType} permissions={permissions} setPermissions={setPermissions} shortName={props.shortName} />;
                              } else {
                                return null;
                              }
                            } catch (error) {
                              console.error("Error rendering FormInput:", error);
                              return null;
                            }
                          })}
                      </Form>
                    </Tab>
                    }

})}
                </TabItems>
              </TabContainer>
            )}
          </React.Fragment>
        )}

        {props.shortName!=="forms" && <Footer>
          {delPrivilege && !(props.bulkUpload ?? false) && (
            <More
              key={`delete`}
              onClick={() => {
                setMessage({
                  type: 2,
                  content: t("deleteItem"),
                  proceed: t("delete"),
                  onProceed: deleteHandler ? deleteHandler : () => alert("not a function"),
                  data: { ...formValues, _id: updateId },
                });
              }}
              className="delete left"
            >
              <GetIcon icon={"delete"} />
            </More>
          )}
          <FormInput type="close" value={t("cancel")} onChange={closeModal} />
          <FormInput disabled={submitDisabled} type="submit" name="submit" value={props.button ? props.button : t("submit")} onChange={props.bulkUpload ? bulkUploadHandler : submitChange} />
        </Footer>}
        </FormMainContainer>
      </Page>
    </Overlay>
  );
};

export default CrudForm;
